import {
  css, type SerializedStyles,
} from '@emotion/react';
import { forwardRef } from 'react';
import { COLOR_PICKER_HOVER_GROUP_CLASS_NAME } from '../colorPicker.constants';
import {
  ColorPickerAlignment, type ColorPickerHolderMethods,
} from '../colorPickerHolder/colorPickerHolder.component';
import { ColorPickerHolderWithPresetColorsContainer } from '../colorPickerHolder/colorPickerHolderWithPresetColors.container';
import { type MaptiveColorPickerProps } from '../maptiveColorPicker/maptiveColorPicker.component';
import { ColorWheelComponent } from './colorWheel.component';

const WHEEL_HOVER_SCALE = 1.2;

const contentStyle = css({ display: 'flex' });

const wheelStyle = css({
  transition: 'scale .15s',
  [`&:hover, .${COLOR_PICKER_HOVER_GROUP_CLASS_NAME}:hover &`]: {
    scale: `${WHEEL_HOVER_SCALE}`,
  },
});

export type ColorPickerWithWheelProps = MaptiveColorPickerProps & Readonly<{
  onOpen?: () => void;
  contentStyle?: SerializedStyles;
  alignment?: ColorPickerAlignment;
}>;

export const ColorPickerWithWheelComponent = forwardRef<ColorPickerHolderMethods, ColorPickerWithWheelProps>((props, ref) => (
  <ColorPickerHolderWithPresetColorsContainer
    ref={ref}
    {...props}
    alignment={props.alignment ?? ColorPickerAlignment.BottomCenter}
    contentStyle={css([contentStyle, props.contentStyle])}
    isFixed
    selectedColor={props.selectedColor}
  >
    <ColorWheelComponent css={wheelStyle} />
  </ColorPickerHolderWithPresetColorsContainer>
));
